import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import "./styles.css";

const tiempos = [10, 15, 20, 25, 30, 35];

const getRandomNumber = () => Math.floor(Math.random() * 6) + 1;

export default function DadosAPleno() {
  const [resultado, setResultado] = useState({
    accion: 1,
    zona: 1,
    intensidad: 1,
    tiempo: 1,
  });

  const [animacion, setAnimacion] = useState(false);
  const [musicaEncendida, setMusicaEncendida] = useState(false);
  const [contador, setContador] = useState(null);
  const [cronometroActivo, setCronometroActivo] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(process.env.PUBLIC_URL + "/musica.wav");
    audioRef.current.loop = true;

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  const toggleMusica = () => {
    if (!audioRef.current) return;

    if (musicaEncendida) {
      audioRef.current.pause();
    } else {
      // Iniciar música solo si el usuario ha hecho clic, evitando bloqueos
      audioRef.current.play().then(() => {
        console.log("Música reproducida con éxito.");
      }).catch((error) => {
        console.warn("El navegador bloqueó la reproducción automática. El usuario debe hacer clic nuevamente.", error);
      });
    }
    
    setMusicaEncendida(!musicaEncendida);
  };

  const lanzarDados = () => {
    setAnimacion(true);
    setTimeout(() => {
      const nuevoResultado = {
        accion: getRandomNumber(),
        zona: getRandomNumber(),
        intensidad: getRandomNumber(),
        tiempo: getRandomNumber(),
      };
      setResultado(nuevoResultado);
      setContador(tiempos[nuevoResultado.tiempo - 1]); 
      setCronometroActivo(false);
      setAnimacion(false);
    }, 1000);
  };

  const iniciarCuentaRegresiva = () => {
    if (contador > 0) {
      setCronometroActivo(true);
      const interval = setInterval(() => {
        setContador((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCronometroActivo(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  return (
    <div className="container">
      {/* Logo del Juego */}
      <img src="assets/logodadosapleno.png" alt="Logo Dados a Pleno" className="logo" />

      {/* Animación de los Dados */}
      <div className="dado-container">
        <motion.img
          src={`/assets/dado_accion_${resultado.accion}.png`}
          alt="Dado Acción"
          className="dado-img dado-grande"
          animate={{ rotate: animacion ? 360 : 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
        <motion.img
          src={`/assets/dado_zona_${resultado.zona}.png`}
          alt="Dado Zona"
          className="dado-img dado-grande"
          animate={{ rotate: animacion ? -360 : 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
        <motion.img
          src={`/assets/dado_intensidad_${resultado.intensidad}.png`}
          alt="Dado Intensidad"
          className="dado-img dado-grande"
          animate={{ rotate: animacion ? 360 : 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
        <motion.img
          src={`/assets/dado_tiempo_${resultado.tiempo}.png`}
          alt="Dado Tiempo"
          className="dado-img dado-grande"
          animate={{ rotate: animacion ? -360 : 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
      </div>

      {/* Tiempo Asignado */}
      <div className="tiempo-asignado">
        <p><strong>⏳ Tiempo asignado: {tiempos[resultado.tiempo - 1]} segundos</strong></p>
      </div>

      {/* Cuenta Regresiva (más grande y en negrita) */}
      <div className="cronometro">{cronometroActivo ? <strong style={{ fontSize: "28px" }}>{contador}</strong> : ""}</div>

      {/* Botón para Iniciar Cuenta Regresiva */}
      <button className="boton-cuenta" onClick={iniciarCuentaRegresiva} disabled={cronometroActivo}>
        Iniciar Cuenta Regresiva
      </button>

      {/* Botón para Lanzar Dados */}
      <button className="boton-lanzar" onClick={lanzarDados}>
        🎲 Lanzar Dados
      </button>

      {/* Botón de Sonido */}
      <button className="boton-musica" onClick={toggleMusica}>
        <img 
          src={musicaEncendida ? "/assets/audio_on.png" : "/assets/audio_off.png"} 
          alt="Botón Música" 
          className="boton-musica-img"
        />
      </button>

      {/* Etiqueta <audio> oculta */}
      <audio ref={audioRef} src="/musica.wav" />
    </div>
  );
}


